var HeadingDisplaySizes;
(function (HeadingDisplaySizes) {
    HeadingDisplaySizes["EXTRA_SMALL"] = "extra-small";
    HeadingDisplaySizes["SMALL"] = "small";
    HeadingDisplaySizes["MEDIUM"] = "medium";
    HeadingDisplaySizes["LARGE"] = "large";
})(HeadingDisplaySizes || (HeadingDisplaySizes = {}));
var AvatarTypes;
(function (AvatarTypes) {
    AvatarTypes["char"] = "InitialAvatarChar";
    AvatarTypes["icon"] = "InitialAvatarIcon";
    AvatarTypes["image"] = "InitialAvatarImage";
})(AvatarTypes || (AvatarTypes = {}));

export { AvatarTypes, HeadingDisplaySizes };
//# sourceMappingURL=types.js.map
